import { Typography, message } from "antd";
import React from "react";
import { useLocation } from "react-router-dom";
import superkulLogo from "../../assets/image/superkul-logo.png";
import { useEffect } from "react";
import { generateErrorMessage, sendGetRequest } from "../../services/request-adapter";

const { Title, Text } = Typography;

const OrganismLoginLayout = ({ title, text, children }) => {

  useEffect(() => {
    checkMaintenance()
  }, []);

  const checkMaintenance = async () => {
    try {
      const { data } = await sendGetRequest('/maintenance')
      if (data == 1) window.location.href = `${process.env.REACT_APP_SUBWEB_URL}/maintenance`
    } catch (error) {
      message.error(generateErrorMessage(error))
    }
  }

  return (
    <div className="content-center relative">
      <img
        width={214}
        src={superkulLogo}
        alt="error"
        className="absolute top-10"
      />
      <div className="bg-image" />
      <div className="login-form">
        <div className="text-center" style={{ marginBottom: "1rem" }}>
          <Title level={1}>{title}</Title>
          <Text className="fs-12" type="secondary">
            {text}
          </Text>
        </div>
        {children}
      </div>
    </div>
  );
};

export default OrganismLoginLayout;
